export enum FormaPagamentoEnum {
    debito = 0,
    credito = 1,
    pix = 2,
    dinheiro = 3,
}